var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "preWarning" },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleTabClick },
          model: {
            value: _vm.activateTab,
            callback: function($$v) {
              _vm.activateTab = $$v
            },
            expression: "activateTab"
          }
        },
        _vm._l(_vm.warningModules, function(item) {
          return _c(
            "el-tab-pane",
            { key: item.module, attrs: { name: item.module } },
            [
              _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                _c("span", { staticClass: "tabSpanStyle" }, [
                  _vm._v(_vm._s(item.moduleName))
                ]),
                _c("span", [_vm._v("(")]),
                _c("span", { staticStyle: { color: "#f56c6c" } }, [
                  _vm._v(_vm._s(_vm.warningCounts[item.module] || 0))
                ]),
                _c("span", [_vm._v(")")])
              ]),
              _c("tab-warning", {
                key: item.module,
                ref: item.module,
                refInFor: true,
                attrs: { module: item.module },
                on: { resetCount: _vm.resetLobCount }
              })
            ],
            1
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }